import {AppState} from "../index";
import {createSelector} from "reselect";
import {IFile} from "./types";
import {IFileData} from "./filedata/types";
import {IdObjectsWithId} from "../../utils";

export const selectFiles = (state: AppState) => state.filesSystem.files
export const selectIsFilesLoading = (state: AppState) => state.filesSystem.isFilesLoading
export const selectSelectedFileId = (state: AppState) => state.filesSystem.selectedFileId
export const selectCheckedFileIds = (state: AppState) => state.filesSystem.checkedFileIds
export const selectFilesData = (state: AppState) => state.filesSystem.filesData
export const selectActiveFileData = (state: AppState) => state.filesSystem.activeFileData
export const selectIsFileSystemLoading = (state: AppState) => state.bannerTemplates.isLoading || state.filesSystem.isFilesLoading
export const selectIsSavingFileData = (state: AppState) => state.filesSystem.isSavingFileData

export const selectRoot = createSelector(
    [selectFiles],
    (files): IFile | undefined => {
        return Object.values(files.byId).find((item) => {
            return item.path === '/'
        });
    });


export const selectSelectedFile = createSelector(
    [selectFiles, selectSelectedFileId],
    (files, id): IFile | undefined => {
        if (id) {
            return files.byId[id]
        }
        return undefined;
    });

export const selectFileDataById = createSelector(
    selectFilesData,
    (state: AppState, id: string) => id,
    (filesData, id): IFileData | undefined => {
        if (id) {
            return filesData.byId[id]
        }
        return undefined;
    });

export const selectIsActiveFileDataModified = createSelector(
    selectFilesData,
    selectActiveFileData,
    (filesData, activeFileData): boolean => {
        if (activeFileData) {
            const origin = filesData.byId[activeFileData.id]
            if (origin && activeFileData.data === origin.data) {
                return false
            }
        }
        return true
    });

export const selectActiveFileDataOriginal = createSelector(
    selectFilesData,
    selectActiveFileData,
    (filesData, activeFileData): IFileData | undefined => {
        if (activeFileData) {
            const origin = filesData.byId[activeFileData.id]
            if (origin && activeFileData.data) {
                return origin
            }
        }
        return undefined
    });
